var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showNotice)?_c('div',{staticClass:"webNotice"},[_c('span',{staticStyle:{"float":"right","cursor":"pointer","margin-right":"10px"},on:{"click":_vm.closeBox}},[_vm._v("关闭×")]),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.webNotice.content)}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-293bb193","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WebNotice/index.vue
// module id = null
// module chunks = 